/**
 * The seven departments. These are the cliques.
 *
 * `colour` is load-bearing, not decoration: it is the only thing telling you
 * which department an NPC belongs to in a greybox where every NPC is the same
 * capsule. They have to be distinguishable at forty feet in a dim corridor, so
 * they are spread around the wheel rather than chosen to be pretty.
 */

export const DEPARTMENTS = [
  {
    id: 'banquets',
    name: 'Banquets',
    short: 'BANQ',
    colour: 0xd2b14a,
    blurb: 'Yours. Sets the room, breaks the room, blamed for the room.',
  },
  {
    id: 'kitchen',
    name: 'Kitchen',
    short: 'KTCH',
    colour: 0xd0563f,
    blurb: 'Owns the food and the tempers. Counts are always wrong and never theirs.',
  },
  {
    id: 'housekeeping',
    name: 'Housekeeping',
    short: 'HSKP',
    colour: 0x56b0a0,
    blurb: 'Owns the linen. Owns the carts. Owns, in practice, the back corridor.',
  },
  {
    id: 'valet',
    name: 'Valet',
    short: 'VALT',
    colour: 0x7f8de0,
    blurb: 'Outside people. Know every guest by car and every manager by schedule.',
  },
  {
    id: 'frontdesk',
    name: 'Front Desk',
    short: 'DESK',
    colour: 0xc47fd0,
    blurb: 'Marble side. Decides what the guest thinks happened.',
  },
  {
    id: 'engineering',
    name: 'Engineering',
    short: 'ENGR',
    colour: 0x9aa35c,
    blurb: 'Keys to everything, loyalty to nothing. Fix things slowly for people they dislike.',
  },
  {
    id: 'management',
    name: 'Management',
    short: 'MGMT',
    colour: 0xb0b7c4,
    blurb: 'Write-ups, schedules, and the belief that they are on everybody’s side.',
  },
];

export const DEPARTMENT_IDS = DEPARTMENTS.map((department) => department.id);

export const byId = Object.fromEntries(DEPARTMENTS.map((d) => [d.id, d]));

export default DEPARTMENTS;
